import { getEmbedded } from '@mode/shared/util-halogen';

import { HasThoughtspotPublication, ReportResource } from './report-response.types';

export function isPublished(resource: ReportResource): resource is HasThoughtspotPublication {
  const hasPublisher = getEmbedded(resource, 'thoughtspot_publisher') !== undefined;
  const hasPublishedAt = typeof resource.thoughtspot_published_at === 'string';

  return hasPublisher && hasPublishedAt;
}

export function isTSPublishMetaData(resource: ReportResource): resource is HasThoughtspotPublication {
  const hasTSPublishMetaData = getEmbedded(resource, 'ts_publish_metadata') !== undefined;

  return hasTSPublishMetaData;
}
